import { HttpService, Messages, ServiceEndpoints } from '@/config/NextImport'
import { decryptData, encryptData } from '@/constants/Common'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import Cookies from 'js-cookie'

const initialState: {
  message: string
  wishlistProducts: any[]
  status: boolean
  loading: boolean
} = {
  message: '',
  wishlistProducts: [],
  status: false,
  loading: true
}

export const addToWishlist = createAsyncThunk(
  'wishlist/addToWishlist',
  async ({ item, user, isFromReviewStep = false }: any) => {
    const obj = {
      setting_sku: '',
      diamond_sku: ''
    }
    if (item.is_diamond === 1) {
      obj.diamond_sku = item.sku
    } else if (item.is_diamond === 0) {
      obj.setting_sku = item.sku
    } else if (isFromReviewStep) {
      obj.diamond_sku = item.diamond_sku
      obj.setting_sku = item.setting_sku
    }

    let param, param1
    if (user) {
      param = {
        setting_sku: obj.setting_sku,
        diamond_sku: obj.diamond_sku,
        customer_id: user.id
      }
    } else {
      param1 = {
        setting_sku: obj.setting_sku,
        diamond_sku: obj.diamond_sku,
        uuid: Cookies.get(Messages.uuid)
      }
    }
    const WishList = JSON.parse(decryptData(localStorage.getItem(Messages.WishList)!) || '[]')

    const existsInData = WishList.some(
      (x: any) => x.setting_sku === obj.setting_sku && x.diamond_sku === obj.diamond_sku
    )

    if (!existsInData) {
      if (user) {
        const response = await HttpService.postApi(ServiceEndpoints.storeWishlistProduct, param)
        return response?.result[0] || null
      } else {
        const response = await HttpService.postApi(ServiceEndpoints.storeGuestWishlistData, param1)
        return response?.result || null
      }
    } else {
      if (user) {
        const response = await HttpService.postApi(ServiceEndpoints.removeWishlistItem, param)
        return response?.result[0] || null
      } else {
        const response = await HttpService.postApi(ServiceEndpoints.removeGuestWishlistData, param1)
        return response?.result || null
      }
    }
  }
)

export const getWishListProduct = createAsyncThunk('wishlist/getWishListProduct', async () => {
  const products = JSON.parse(decryptData(localStorage.getItem(Messages.WishList)!) || '[]')

  const param = {
    products
  }

  try {
    const response = await HttpService.postApi(ServiceEndpoints.getWishListProduct, param)

    if (response.result?.length > 0) {
      const product: any = []
      const data = response.result
      data.forEach((element: any) => {
        if (
          element.Products !== undefined &&
          element.Products[0] !== undefined &&
          element.Products[0][0] !== undefined &&
          element.Products.length > 1
        ) {
          element.Products.detail_url = element.url
          element.Products.diamond_sku = element.diamond_sku
          element.Products.setting_sku = element.setting_sku

          element.Products.forEach((ele: any) => {
            if (ele.length > 0) {
              if (ele[0].is_sold === 1) {
                ele[0].subtotal = element.Products[element.Products.length - 1][0].formated_price
                element.Products.is_sold = 1
              }
              if (ele[0].is_diamond === 0) {
                element.Products.is_setting = 1
              }
            }
          })
          product.push(element.Products)
        } else {
          if (
            element.Products !== undefined &&
            element.Products[0] !== undefined &&
            element.Products[0][0] !== undefined
          ) {
            element.Products[0].detail_url = element.url
            element.Products[0].diamond_sku = element.diamond_sku
            element.Products[0].setting_sku = element.setting_sku
            product.push(element.Products[0])
          }
        }
      })
      return product
    }
  } catch (error) {
    console.error(error)
  }
})

export const getWishlistItems = createAsyncThunk('wishlist/getWishlistItems', async (user: any) => {
  const param = {
    customer_id: user?.id
  }
  const response = await HttpService.postApi(ServiceEndpoints.getWishlistItems, param)
  return response?.result[0] || null
})

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    clearWishList: (state) => {
      localStorage.removeItem(Messages.WishList)
      state.wishlistProducts = []
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addToWishlist.fulfilled, (state, action) => {
        if (action.payload) {
          localStorage.setItem(Messages.WishList, encryptData(JSON.stringify(action.payload)))
        }
      })
      // .addCase(getWishListProduct.pending, (state) => {
      //   state.loading = true;
      // })
      .addCase(getWishListProduct.fulfilled, (state, action) => {
        state.loading = false
        state.wishlistProducts = action.payload || []
      })
      // .addCase(getWishListProduct.rejected, (state, action) => {
      //   state.loading = false;
      // })
      .addCase(getWishlistItems.fulfilled, (state, action) => {
        if (action.payload) {
          localStorage.setItem(Messages.WishList, encryptData(JSON.stringify(action.payload)))
        }
      })
  }
})

export const { clearWishList } = wishlistSlice.actions
export default wishlistSlice.reducer
